<template>
  <div :class="`${prefixCls}-wrapper`">
    <div :class="`${prefixCls}`">
      <slot></slot>
    </div>
  </div>
  <!--
    ignore: wrapperStyle, offsetTop, wrapperClass, inkClass
    ignore: div.ink, div.linkNode, 
    ignore: showInkInFixed, getDefaultContainer, AnchorProps
    
    {$slots.default}
  -->
</template>


<script>
import addEventListener from "../utils/addEventListener";
import getScroll from "../utils/getScroll";
import raf from "raf";

function getOffsetTop(element, container) {
  if (!element) {
    return 0;
  }

  if (!element.getClientRects().length) {
    return 0;
  }

  const rect = element.getBoundingClientRect();

  if (rect.width || rect.height) {
    if (container === window) {
      container = element.ownerDocument.documentElement;
      return rect.top - container.clientTop;
    }
    return rect.top - container.getBoundingClientRect().top;
  }

  return rect.top;
}

function easeInOutCubic(t, b, c, d) {
  const cc = c - b;
  t /= d / 2;
  if (t < 1) {
    return (cc / 2) * t * t * t + b;
  }
  return (cc / 2) * ((t -= 2) * t * t + 2) + b;
}

const sharpMatcherRegx = /#([^#]+)$/;
function scrollTo(
  href,
  offsetTop = 0,
  getContainer,
  callback = () => {},
  duration = 450
) {
  const container = getContainer();
  const scrollTop = getScroll(container, true);
  const sharpLinkMatch = sharpMatcherRegx.exec(href);
  if (!sharpLinkMatch) {
    return;
  }
  const targetElement = document.getElementById(sharpLinkMatch[1]);
  if (!targetElement) {
    return;
  }
  const eleOffsetTop = getOffsetTop(targetElement, container);
  const targetScrollTop = scrollTop + eleOffsetTop - offsetTop;
  const startTime = Date.now();
  const frameFunc = () => {
    const timestamp = Date.now();
    const time = timestamp - startTime;
    const nextScrollTop = easeInOutCubic(
      time,
      scrollTop,
      targetScrollTop,
      duration
    );
    if (container === window) {
      window.scrollTo(window.pageXOffset, nextScrollTop);
    } else {
      container.scrollTop = nextScrollTop;
    }
    if (time < duration) {
      raf(frameFunc);
    } else {
      callback();
    }
  };
  raf(frameFunc);
}

export default {
  name: "AAnchor",
  props: {
    prefixCls: {
      type: String,
      default: "ant-anchor"
    },
    getContainer: {
      type: Function,
      default: () => {
        return window;
      }
    }
  },
  data() {
    this.links = [];
    return {
      activeLink: null
    };
  },
  provide() {
    return {
      antAnchor: {
        registerLink: link => {
          if (!this.links.includes(link)) {
            this.links.push(link);
          }
        },
        unregisterLink: link => {
          const index = this.links.indexOf(link);
          if (index !== -1) {
            this.links.splice(index, 1);
          }
        },
        $data: this.$data,
        scrollTo: this.handleScrollTo
      },
      antAnchorContext: this
    };
  },

  methods: {
    handleScroll() {
      if (this.animating) {
        return;
      }
      const { offsetTop, bounds } = this;

      this.activeLink = this.getCurrentAnchor(offsetTop, bounds);
    },

    handleScrollTo(link) {
      const { offsetTop, getContainer } = this;
      this.animating = true;
      //   this.setState({ activeLink: link });
      this.activeLink = link;
      scrollTo(link, offsetTop, getContainer, () => {
        this.animating = false;
      });
    },

    getCurrentAnchor(offsetTop = 0, bounds = 5) {
      const activeLink = "";
      if (typeof document === "undefined") {
        return activeLink;
      }

      const linkSections = [];
      const { getContainer } = this;
      const container = getContainer();
      this.links.forEach(link => {
        const sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
        if (!sharpLinkMatch) {
          return;
        }
        const target = document.getElementById(sharpLinkMatch[1]);
        if (target) {
          const top = getOffsetTop(target, container);
          if (top < offsetTop + bounds) {
            linkSections.push({
              link,
              top
            });
          }
        }
      });

      if (linkSections.length) {
        const maxSection = linkSections.reduce((prev, curr) =>
          curr.top > prev.top ? curr : prev
        );
        return maxSection.link;
      }
      return "";
    }
  },

  mounted() {
    this.$nextTick(() => {
      const { getContainer } = this;
      this.scrollEvent = addEventListener(
        getContainer(),
        "scroll",
        this.handleScroll
      );
      this.handleScroll();
    });
  },

  beforeDestroy() {
    if (this.scrollEvent) {
      this.scrollEvent.remove();
    }
  },

  updated() {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/privacyCloud/components/anchor.vue